<template>
  <div class="language-selector">
    <select
      v-model="currentLocale"
      @change="changeLocale"
      class="rounded-lg border-gray-300 shadow-sm focus:border-primary focus:ring-primary text-sm"
    >
      <option value="fr">Français</option>
      <option value="en">English</option>
      <option value="de">Deutsch</option>
    </select>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { setLocale, getLocale, detectBrowserLocale } from '@/i18n'

const currentLocale = ref(getLocale())

function changeLocale(event: Event) {
  const target = event.target as HTMLSelectElement
  setLocale(target.value)
  document.documentElement.lang = target.value
}

onMounted(() => {
  // Détecte et définit la langue du navigateur au premier chargement
  const browserLocale = detectBrowserLocale()
  setLocale(browserLocale)
  currentLocale.value = browserLocale
  document.documentElement.lang = browserLocale
})
</script>

<style scoped>
.language-selector select {
  padding: 0.5rem 2rem 0.5rem 1rem;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%236B7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3E%3C/svg%3E");
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
}
</style> 